import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { saveAs } from 'file-saver';
import { FileSaverUsecase } from '../../domain/model/file-saver-usecase.enum';
import moment from 'moment';


@Injectable({
    providedIn: 'root',
})
export class OrganisationenExportService {
    private http = inject(HttpClient);


    private static readonly APPLICATION_PREFIX = 'UFLA';
    private static readonly TIMESTAMP_FORMAT = 'YYYY-MM-DD_HH-mm-ss';

    public exportOrganisationen() {
        const httpOptions = {
            headers: new HttpHeaders({
                'Accept': 'text/csv',
            }),
        };

        this.http.get(environment.API_URL + '/organisation/organisation_csv', {
            ...httpOptions,
            responseType: 'blob',
        }).subscribe(res => {
            const fileName = OrganisationenExportService.buildFilename(FileSaverUsecase.CSV_EXPORT_NETZBETREIBER);
            saveAs(res, fileName);
        });
    }

    private static getFilenameUsecaseAndExtensionFromUsecase(usecase: FileSaverUsecase): [string, string] {
        switch (usecase) {
            case FileSaverUsecase.CSV_EXPORT_NETZBETREIBER:
                return [
                    'Netzbetreiber',
                    'csv',
                ];
            default:
                throw new Error('Usecase not implemented.');
        }
    }

    private static buildFilename(usecase: FileSaverUsecase): string {
        const [
            filenameUsecase,
            fileExtension,
        ] = this.getFilenameUsecaseAndExtensionFromUsecase(usecase);
        const timestamp = moment().format(this.TIMESTAMP_FORMAT);

        let filename = `${this.APPLICATION_PREFIX}_${filenameUsecase}_${timestamp}`;
        return `${filename}.${fileExtension}`;
    }
}
